import { render, staticRenderFns } from "./TransactionsTable.vue?vue&type=template&id=0bc6724f&scoped=true&lang=html&"
import script from "./TransactionsTable.vue?vue&type=script&lang=js&"
export * from "./TransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsTable.vue?vue&type=style&index=0&id=0bc6724f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6724f",
  null
  
)

export default component.exports